import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import { StoreContext } from 'store/context'
import AthletesAddComponent from './component'

export const AthletesAdd = combine(
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),
  withContext('appStore', StoreContext),
  withCallback(
    'onSubmit',
    ({ adminAthletesService, appStore }, { history }) =>
      async (athleteDTO) => {
        await adminAthletesService.createAthlete(athleteDTO)
        appStore.adminAthletes.onAthleteAdded()
        toaster.info('Athlete has been successfully created')
        history.push(admin.athletes())
      },
    []
  )
)(AthletesAddComponent)
